<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'setting'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('common.shopsettings')}}</h1>
						</div>
						<div class="form-container">
							<form @submit.prevent="saveSettings">
								<!-- Basic Info Section -->
								<div class="form-section">
									<h3 class="section-title">{{$t('common.basicinfo')}}</h3>

									<!-- Shop Name -->
									<div class="form-item">
										<label class="form-label">{{$t('form.shopname')}}</label>
										<input v-model="formBase.storeName" type="text" class="form-input"
											:placeholder="$t('tips.entershopname')" />
									</div>

									<!-- Shop Logo -->
									<div class="form-item">
										<label class="form-label">{{$t('form.shoplogo')}}</label>
										<div class="logo-upload-container">
											<!--                      <div v-if="!formBase.storePhoto" class="upload-placeholder"-->
											<!--                           type="file"  accept="image/*"-->
											<!--                           @change="triggerFileInput">-->
											<!--                        <span>+</span>-->
											<!--                      </div>-->
											<!--                      <img v-else :src="" alt="Shop Logo" class="uploaded-logo" />-->
											<div class="upload-area" style="position: relative;">
												<input
													style="width:100%;height:100%;opacity:0;position: absolute;top:0;left:0;z-index: 2;cursor: pointer;"
													type="file" accept="image/*" @change="onFileChange" />
												<div v-if="!formBase.storePhoto" class="upload-placeholder">
													<span>+</span>
												</div>
												<img v-else :src="formBase.storePhoto" alt="Uploaded photo"
													class="uploaded-img" />
											</div>
										</div>
									</div>

									<!-- Shop Phone -->
									<div class="form-item">
										<label class="form-label">{{$t('form.shopphone')}}</label>
										<input v-model="formBase.storePhone" type="tel" class="form-input"
											:placeholder="$t('tips.entershopphone')" />
									</div>

									<!-- Introduction -->
									<div class="form-item">
										<label class="form-label">{{$t('form.introduction')}}</label>
										<textarea v-model="formBase.storeIntroduction" class="form-textarea"
											:placeholder="$t('tips.entershopintroduction')" rows="3"></textarea>
									</div>

									<!-- Shop Address -->
									<div class="form-item">
										<label class="form-label">{{$t('form.shopaddress')}}</label>
										<input v-model="formBase.storeAddress" type="text" class="form-input"
											:placeholder="$t('tips.entershopaddress')" />
									</div>

									<!-- Save Button -->
									<div class="form-actions">
										<button type="button" class="btn-save" @click="handleBase">{{$t('button.save')}}</button>
									</div>
								</div>
							</form>
						</div>

						<div class="form-container" style="margin-top: 20px;">

							<!-- Basic Info Section -->
							<div class="form-section">
								<h3 class="section-title">{{$t('form.bannersetting')}}</h3>
								<!-- Shop Logo -->
								<div class="form-item">
									<label class="form-label">{{$t('form.banner')}}</label>
									<template v-if="formBanner.bannerPhoto.length > 0" >
										<div class="logo-upload-container" v-for="(banner,index) in formBanner.bannerPhoto">
											<img :src="banner" class="uploaded-img" />
											<img src="../../assets/images/del2.png" class="del-icon" @click="delFile(index)" />
										</div>
									</template>
									<div class="logo-upload-container">
										<input style="width:100%;height:100%;opacity:0;position:absolute;top:0;left:0;z-index: 2;cursor: pointer;position: absolute;" type="file" accept="image/*" @change="onFileChange2" />
										<div class="upload-placeholder">
											<span>+</span>
										</div>
									</div>
								</div>
								<!-- Save Button -->
								<div class="form-actions">
									<button type="button" @click="handleBanner" class="btn-save">{{$t('button.save')}}</button>
								</div>
							</div>

						</div>

						<div class="form-container" style="margin-top: 20px;">

							<!-- Basic Info Section -->
							<div class="form-section">
								<h3 class="section-title">{{$t('common.basicinfo')}}</h3>

								<!-- Shop Phone -->
								<div class="form-item">
									<label class="form-label">Facebook</label>
									<input v-model="formContact.facebook" type="tel" class="form-input"
										placeholder="Facebook" />
								</div>

								<!-- Introduction -->
								<div class="form-item">
									<label class="form-label">Instagram</label>
									<input v-model="formContact.instagram" type="text" class="form-input"
										placeholder="Instagram" />
								</div>

								<!-- Shop Address -->
								<div class="form-item">
									<label class="form-label">Twitter</label>
									<input v-model="formContact.twitter" type="text" class="form-input"
										placeholder="Twitter" />
								</div>

								<!-- Shop Address -->
								<div class="form-item">
									<label class="form-label">Google</label>
									<input v-model="formContact.google" type="text" class="form-input"
										placeholder="Google" />
								</div>

								<!-- Shop Address -->
								<div class="form-item">
									<label class="form-label">Youtube</label>
									<input v-model="formContact.youtube" type="text" class="form-input"
										placeholder="Youtube" />
								</div>

								<!-- Save Button -->
								<div class="form-actions">
									<button type="button" @click="handleContact" class="btn-save">{{$t('button.save')}}</button>
								</div>
							</div>

						</div>


					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		storeDetail,
		updateStoreBase,
		updateStoreBanner,
		updateStoreContact,
		uploadFile
	} from '../../api/home'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				selectedFile: null,
				selectedFile2: null,
				formBase: {
					storeName: null,
					storePhoto: null,
					storePhone: null,
					storeIntroduction: null,
					shopAddress: null
				},
				formContact: {
					facebook: null,
					instagram: null,
					twitter: null,
					google: null,
					youtube: null
				},
				formBanner: {
					bannerPhoto: [],
				},
				tableLoading: false,
			}
		},
		created() {
			this.getStoreDetail();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			onFileChange2(e) {
				this.selectedFile2 = e.target.files[0];
				this.uploadPhoto2()
			},
			// 修改 uploadPhoto 方法
			uploadPhoto2() {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile2, this.selectedFile2.name);
				let file = formData
				uploadFile(file).then(res => {
					if (res.code == 200) {
						// 假设接口返回的文件URL在 res.data.url 中
						//this.formBanner.bannerPhoto = res.url;
						this.formBanner.bannerPhoto.push(res.url)
						this.$message.success('Image uploaded successfully');
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(res.msg || 'Image upload failed');
				});
			},
			onFileChange(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto()
			},
			// 修改 uploadPhoto 方法
			uploadPhoto() {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile, this.selectedFile.name);
				let file = formData
				uploadFile(file).then(res => {
					if (res.code == 200) {
						// 假设接口返回的文件URL在 res.data.url 中
						this.formBase.storePhoto = res.url;
						this.$message.success('Image uploaded successfully');
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(res.msg || 'Image upload failed');
				});
			},
			triggerFileInput(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto()
			},
			handleContact() {
				updateStoreContact(this.formContact).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tips.updatestorecontactsuccess'))
						this.getStoreDetail();
					}
				})
			},
			handleBanner() {
				if (this.formBanner.bannerPhoto.length <= 0) {
					this.$message.error(this.$t('tips.reuqirebannerphoto'))
					return
				}
				var bannerPhoto = ''
				this.formBanner.bannerPhoto.forEach((item) => {
					bannerPhoto = bannerPhoto + item + ','
				});
				bannerPhoto = bannerPhoto.substring(0, bannerPhoto.lastIndexOf(','));
				var params = {
					bannerPhoto:bannerPhoto
				}
				updateStoreBanner(params).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tips.updatestorebannersuccess'))
						this.getStoreDetail();
					}
				})
			},

			handleBase() {
				if (!this.formBase.storeName) {
					this.$message.error(this.$t('tips.entershopname'))
					return
				}
				/*if (!this.formBase.storePhone) {
					this.$message.error('Please enter the store phone')
					return
				}
				if (!this.formBase.storeIntroduction) {
					this.$message.error('Please enter the store introduction')
					return
				}
				if (!this.formBase.storeAddress) {
					this.$message.error('Please enter the store address')
					return
				}*/
				updateStoreBase(this.formBase).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tips.updatestorebaseinfosuccess'))
						this.getStoreDetail();
					}
				})
			},
			getStoreDetail() {
				storeDetail().then(res => {
					if (res.code == 200) {
						this.formBase.storeName = res.data.storeName
						this.formBase.storePhoto = res.data.storePhoto
						this.formBase.storePhone = res.data.storePhone
						this.formBase.storeIntroduction = res.data.storeIntroduction
						this.formBase.storeAddress = res.data.storeAddress
						this.formBanner.bannerPhoto = res.data.photos
						this.formContact.facebook = res.data.facebook
						this.formContact.instagram = res.data.instagram
						this.formContact.twitter = res.data.twitter
						this.formContact.google = res.data.google
						this.formContact.youtube = res.data.youtube

					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
			delFile(index){
				this.formBanner.bannerPhoto.splice(index, 1);
			},
		}
	}
</script>

<style scoped>
</style>
<style scoped>
	.form-container {
		max-width: 100%;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.form-section {
		margin-bottom: 20px;
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-bottom: 15px;
	}

	.form-item {
		margin-bottom: 15px;
		overflow: hidden;
	}

	.form-label {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #555;
		margin-bottom: 8px;
	}

	.required::after {
		content: " *";
		color: red;
	}

	.form-input,
	.form-textarea {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
	}

	.form-textarea {
		resize: vertical;
	}

	.logo-upload-container {
		float: left;
		position: relative;
		width: 100px;
		height: 100px;
		border: 2px dashed #007bff;
		border-radius: 4px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 8px 8px 0;
	}

	.upload-placeholder {
		width: 100%;
		height: 100%;
		background-color: #f8f9fa;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #007bff;
		cursor: pointer;
	}

	.uploaded-logo {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	.form-actions {
		text-align: right;
		margin-top: 20px;
	}

	.btn-save {
		background-color: #007bff;
		color: white;
		padding: 10px 20px;
		border: none;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
	}

	.btn-save:hover {
		background-color: #0056b3;
	}

	/* 移动端适配 */
	@media (max-width: 768px) {
		.form-container {
			padding: 15px 20px;
		}

		.form-item {
			margin-bottom: 12px;
		}

		.logo-upload-container {
			width: 80px;
			height: 80px;
		}

		.form-input,
		.form-textarea {
			font-size: 13px;
		}

		.btn-save {
			padding: 8px 16px;
			font-size: 13px;
		}
	}
	.del-icon {
		position: absolute;
		right: 1px;
		top: 0px;
		width: 13px;
		height: 13px;
	}
</style>
